import { useContext } from "react";
import "./WarningFormat.css";
import { AppContext } from "../../App";

function WarningFormat({ errorData }) {
  const { showLogs } = useContext(AppContext);
  const { title, messages } = errorData;

  if (showLogs.current) console.log("MESSAGES", messages);

  return (
    <div className="errors-container">
      <h2>{title || "Este proyecto no está disponible para Plano Tipo."}</h2>
      <p style={{ textAlign: "center" }}>
        <b>Se ha enviado una solicitud de soporte al área encargada.</b>
      </p>
      <ul>
        {messages.map((element, index) => {
          return (
            <li className="error-message" key={index}>
              {element}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default WarningFormat;
